module.exports = __webpack_public_path__ + "img/red_019.8c26a156.png";